import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { Licence } from '@classes/licence/licence';
import { LicenceService } from '@services/licence.service';
import { ReportService } from '@services/report.service';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'app-licence-detail',
  templateUrl: './licence-detail.component.html',
  styleUrls: ['./licence-detail.component.scss']
})
export class LicenceDetailComponent implements OnInit, OnDestroy {
    private licenceSub: Subscription;

    licence: Licence;
    isLicenceEditMode: boolean;
    isLicenceManager: boolean;
    isUsersManager: boolean;
    isLoading: boolean;

    constructor(
        private licenceSrv: LicenceService,
        private route: ActivatedRoute,
        private reportSrv: ReportService,
        private authSrv: AuthService
    ) { }

    ngOnInit() {
        this.getRouteData();
        this.getUserRole();
        this.initSubscriptions();
    }

    onExport(): void {
        this.isLoading = true;

        this.reportSrv.generateXlsLicences(this.licence.code)
        .subscribe(() => {
            this.isLoading = false;
        });
    }

    private getRouteData(): void {
        this.route.data
        .subscribe(data => {
            this.licence = data.licence;
        });
    }

    private getUserRole(): void {
        const authUser = this.authSrv.getAuthUser();
        this.isLicenceManager = authUser.isLicencesManager;
        this.isUsersManager = authUser.isUsersManager;
    }

    private initSubscriptions(): void {
        this.licenceSub = this.licenceSrv.selectedLicenceChanged
        .subscribe(licence => {
            this.licence = licence;

            if(this.isLicenceEditMode) {
                this.isLicenceEditMode = false;
            }
        });
    }

    ngOnDestroy() {
        if(this.licenceSub) {
            this.licenceSub.unsubscribe();
        }
    }
}
